<template>
  <el-button
    :type="buttonType"
    :disabled="disabled"
    :loading="loading"
    @click="buttonClick"
  >
    {{ text }}
  </el-button>
</template>

<script>
export default {
  name: 'ItemButton',
  components: {},
  props: {
    text: {
      type: String,
      default: '',
    },
    plain: Boolean,
    disabled: Boolean,
    loading: Boolean,
    path: String,
  },
  data() {
    return {}
  },
  computed: {
    buttonType() {
      if (this.plain) return 'plain'
      else return 'primary'
    },
  },
  methods: {
    buttonClick() {
      if (this.path) {
        this.$router.push(this.path)
      } else {
        this.$emit('click')
      }
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
button {
  border-radius: 0;
  padding: 10px 18px;
  font-size: 18px;
  &.el-button--plain {
    border-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ItemButton.vue